export default __webpack_public_path__ + "icon-workflow89b935.png";